import { Component } from "react";
import autobind from "react-autobind";
import colorPalette from "@streeteasy/design-system/deprecated/colors";
import { isEmpty } from "lodash";
import { arrayOf, bool, func, number, shape, string } from "prop-types";

class Polygon extends Component {
  constructor(props) {
    super(props);
    autobind(this);
  }

  componentDidMount() {
    const canUseDOM = typeof window !== "undefined";
    const shouldInitializePolygon = canUseDOM && !isEmpty(window.google);
    if (shouldInitializePolygon) {
      this.initializePolygon();
    }
  }

  componentDidUpdate() {
    this.handleFillPolygon();
    if (this.props.shouldUpdateOnHover) {
      this.props.onHover({ id: this.props.id, bounds: this.bounds });
    }
  }

  componentWillUnmount() {
    this.polygon.setMap(null);
  }

  setBoundsFromPaths(paths) {
    const bounds = new global.google.maps.LatLngBounds();

    for (let i = 0; i < paths.length; i += 1) {
      bounds.extend(paths[i]);
    }

    this.bounds = bounds;
  }

  handleFillPolygon() {
    const fillLevel = this.props.isSelected ? 0.8 : 0.5;
    const fillOpacity = this.props.fillRegion ? fillLevel : 0;
    this.polygon.setOptions({ fillOpacity });
  }

  handleOnClick() {
    this.props.onClick([this.props.id]);
  }

  handleOnMouseOver() {
    this.props.onHover({ id: this.props.id, bounds: null });
  }

  initializePolygon() {
    const {
      fillColor,
      gmap,
      isSelected,
      paths,
      strokeColor,
      strokeOpacity,
      strokeWeight,
      zIndex
    } = this.props;

    this.polygon = new global.google.maps.Polygon({
      paths,
      strokeColor,
      strokeOpacity,
      strokeWeight,
      fillColor,
      fillOpacity: isSelected ? 0.8 : 0,
      zIndex
    });

    this.polygon.setMap(gmap);

    this.polygon.addListener("click", () => {
      this.handleOnClick();
    });

    this.polygon.addListener("mouseover", () => {
      this.handleOnMouseOver();
    });

    this.setBoundsFromPaths(paths);
  }

  render() {
    return null;
  }
}

Polygon.propTypes = {
  paths: arrayOf(shape()),
  fillRegion: bool,
  strokeWeight: number,
  strokeOpacity: number,
  onHover: func,
  onClick: func,
  shouldUpdateOnHover: bool,
  gmap: shape().isRequired,
  fillColor: string,
  strokeColor: string,
  id: number,
  isSelected: bool,
  zIndex: number
};

Polygon.defaultProps = {
  paths: [],
  fillRegion: false,
  strokeWeight: 2,
  strokeColor: colorPalette.primaryTouched,
  strokeOpacity: 1,
  onHover: () => {},
  onClick: () => {},
  shouldUpdateOnHover: false,
  fillColor: colorPalette.primaryTouched,
  id: null,
  isSelected: false,
  zIndex: 0
};

export default Polygon;
